// store/aceites/index.js

//inicio storage
const STORAGE_SEARCH = 'leon_aceites_search';
const STORAGE_PRODUCTOS = 'leon_aceites_productos';
const STORAGE_DETALLE_AGENDAMIENTO = 'leon_aceites_detalle_agendamiento';
const STORAGE_INFO_ESPECIFICACIONES = 'leon_aceites_info_especificaciones';
const STORAGE_PERSONAL_INFORMATION = 'leon_aceites_personal_information'; 
const STORAGE_SCHEDULE             = 'leon_aceites_schedule';


const to_string = (value) => {
  if (value === null || value === undefined) return '';
  return String(value);
};

const normalizar_search_data = (searchData) => {
  const next = { ...searchData };
  //next.ano = to_string(next.ano);
  next.modelo = to_string(next.modelo);
  next.version = to_string(next.version);

  return next;
};

const getSearchStorage = () => {
  try {
    if (import.meta.client) {
      const search = localStorage.getItem(STORAGE_SEARCH);
      return search ? JSON.parse(search) : null;
    }
  } catch (error) {
    console.warn('Error leyendo search:', error);
  }
  return null;
};

const getProductosStorage = () => {
  try {
    if (import.meta.client) {
      const productos = localStorage.getItem(STORAGE_PRODUCTOS);
      return productos ? JSON.parse(productos) : null;
    }
  } catch (error) {
    console.warn('Error leyendo productos:', error);
  }
  return null;
};

const getDetalleAgendamientoStorage = () => {
  try {
    if (import.meta.client) {
      const productos = localStorage.getItem(STORAGE_DETALLE_AGENDAMIENTO);
      return productos ? JSON.parse(productos) : null;
    }
  } catch (error) {
    console.warn('Error leyendo detalle agendamiento:', error);
  }
  return null;
};

const getInfoEspecificacionesStorage = () => {
  try {
    if (import.meta.client) {
      const productos = localStorage.getItem(STORAGE_INFO_ESPECIFICACIONES);
      return productos ? JSON.parse(productos) : null;
    }
  } catch (error) {
    console.warn('Error leyendo detalle especificaciones:', error);
  }
  return null;
};

// NUEVO
const getPersonalInformationStorage = () => {
  try {
    if (import.meta.client) {
      const personal = localStorage.getItem(STORAGE_PERSONAL_INFORMATION);
      return personal ? JSON.parse(personal) : null;
    }
  } catch (error) {
    console.warn('Error leyendo personal information:', error);
  }
  return null;
};

const setJSON = (storage, data) => setToStorage(storage, data);

const setToStorage = (storage, data) => {
  try {
    if (import.meta.client) {
      localStorage.setItem(storage, JSON.stringify(data));
    }
  } catch (error) {
    console.warn('Error guardando en localStorage:', error);
  }
};
//termino storage

//inicio state
const state = function() {
  return {
    searchData: {
      local: '',
      modo_busqueda: 'directo',
      flujo_agendamiento: 'flujo_directo',
      tipo_aceite: '',
      patente: '',
      marca: '',
      marca_logo: '',
      ano: '',
      modelo: '',
      version: '',
    },

    info_especificaciones: null,
    producto_seleccionado: null,

    detalle_agendamiento: {
      local_direccion: '',
      local_resumen: '',
      modalidad: 1,
      fecha: null,
      hora: null,
      direccion_retiro: {
        region: "",
        comuna: "",
        direccion: "",
        comentario: ""
      },
      direccion_entrega: {
        region: "",
        comuna: "",
        direccion: "",
        comentario: ""
      },
      tempario:'',
    },

    //como meto esto en usecartbridge sin romper nada?
    personalInformation: {
      rut: "",
      nombre: "",
      apellido_paterno: "",
      apellido_materno: "",
      email: "",
      telefono: "",
      pais: "+56",
      patente: "",
      patente_pais: "",
    },

    calendar: {
      tempario: "",
      scheduleType: 3,
    },

  };
};
//termino state

const mutations = {
  // Cargar desde localStorage
  LOAD_FROM_STORAGE: function(state) {
    const storedData = getSearchStorage();
    if (storedData) {
      if (storedData.marca_logo === undefined || storedData.marca_logo === null) {
        storedData.marca_logo = '';
      }
      if (storedData.modo_busqueda === undefined || storedData.modo_busqueda === null || storedData.modo_busqueda === '') {
        storedData.modo_busqueda = 'directo';
      }

      if (storedData.flujo_agendamiento === undefined) {
        storedData.flujo_agendamiento = 'flujo_directo';
      }

      if (storedData.tipo_aceite === undefined || storedData.tipo_aceite === null) {
        storedData.tipo_aceite = '';
      }

      state.searchData = { ...state.searchData, ...storedData };
      state.searchData = normalizar_search_data(state.searchData);
      setToStorage(STORAGE_SEARCH, state.searchData);
    }

    const productosData = getProductosStorage();
    if (productosData) {
      state.producto_seleccionado = productosData;
      console.log('[STORE] Datos cargados desde localStorage para producto_seleccionado:', state.producto_seleccionado);
    }

    const DetalleAgendamiento = getDetalleAgendamientoStorage();
    if (DetalleAgendamiento) {
      if (typeof DetalleAgendamiento.modalidad === 'string') {
        const mapeoModalidad = { 'ESPERA': 1, 'DEJA': 2, 'RETIRA': 3 };
        DetalleAgendamiento.modalidad = mapeoModalidad[DetalleAgendamiento.modalidad] || 1;
      }
      if (!DetalleAgendamiento.modalidad) {
        DetalleAgendamiento.modalidad = 1;
      }

      if (DetalleAgendamiento.direccion_retiro) {
        delete DetalleAgendamiento.direccion_retiro.misma_direccion;
        delete DetalleAgendamiento.direccion_retiro.dejar_auto;
      }
      if (DetalleAgendamiento.direccion_entrega) {
        delete DetalleAgendamiento.direccion_entrega.misma_direccion;
        delete DetalleAgendamiento.direccion_entrega.dejar_auto;
      }

      state.detalle_agendamiento = {
        ...state.detalle_agendamiento,
        ...DetalleAgendamiento
      };
      console.log('[STORE] Datos cargados desde localStorage para detalle_agendamiento:', state.detalle_agendamiento);
    }

    const InfoEspecificaciones = getInfoEspecificacionesStorage();
    if (InfoEspecificaciones) {
      state.info_especificaciones = InfoEspecificaciones;
      console.log('[STORE] Datos cargados desde localStorage para info_especificaciones:', state.info_especificaciones);
    }

    const PersonalInfo = getPersonalInformationStorage();
    if (PersonalInfo) {
      state.personalInformation = PersonalInfo;
      console.log('[STORE] Datos cargados desde localStorage para personalInformation:', state.personalInformation);
    }
  },
  
  // Resets
  RESET_SEARCH_DATA: function(state) {
    state.searchData = {
      local: '',
      flujo_agendamiento: "flujo_directo",
      modo_busqueda: 'directo',
      tipo_aceite: '',

      patente: '',
      marca: '',
      marca_logo: '',
      ano: '',
      modelo: '',
      version: '',
    };
    if (import.meta.client) localStorage.removeItem(STORAGE_SEARCH);
  },

  RESET_INFO_ESPECIFICACIONES: function(state) {
    state.info_especificaciones = null;
    if (import.meta.client) {
      localStorage.removeItem(STORAGE_INFO_ESPECIFICACIONES);
    }
  },

  RESET_PRODUCTO_SELECCIONADO: function(state) {
    state.producto_seleccionado = null;
    if (import.meta.client) {
      localStorage.removeItem(STORAGE_PRODUCTOS);
    }
  },
  
  RESET_DETALLE_AGENDAMIENTO: function(state) {
    state.detalle_agendamiento = {
      local_direccion: '',
      local_resumen: '',
      modalidad: 1,
      fecha: null,
      hora: null,
      direccion_retiro: {
        region: "",
        comuna: "",
        direccion: "",
        comentario: ""
      },
      direccion_entrega: {
        region: "",
        comuna: "",
        direccion: "",
        comentario: ""
      },
      tempario:"",
    };
    if (import.meta.client) {
      localStorage.removeItem(STORAGE_DETALLE_AGENDAMIENTO);
    }
  },

  RESET_PERSONAL_INFORMATION: function(state) {
    state.personalInformation = {
      rut: "",
      nombre: "",
      apellido_paterno: "",
      apellido_materno: "",
      email: "",
      telefono: "",
      pais: "+56",
      patente: "",
      patente_pais: "",
    };
    if (import.meta.client) localStorage.removeItem(STORAGE_PERSONAL_INFORMATION);
  },


  // Sets - Search Data
  SET_SEARCH_DATA: function(state, data) {
    const merged = { ...state.searchData, ...data };

    // FORZAR TIPOS
    state.searchData = normalizar_search_data(merged);

    setToStorage(STORAGE_SEARCH, state.searchData);
  },


  SET_PATENTE_SEARCH: function(state, { patente, local }) {
    state.searchData = {
      ...state.searchData,
      patente,
      local,
      modo_busqueda: 'por_patente',
      flujo_agendamiento: 'flujo_patente',
      marca: '',
      marca_logo: '',
      ano: '',
      modelo: '',
      version: '',
      tipo_aceite: '',
    };
    setToStorage(STORAGE_SEARCH, state.searchData);
  },
  
  SET_AUTO_SEARCH: function(state, { marca, ano, modelo, local, marca_logo = '' }) {
    const next = {
      ...state.searchData,
      marca,
      ano,
      modelo,
      version: '',
      marca_logo: marca_logo || '',
      local,
      modo_busqueda: 'por_auto',
      flujo_agendamiento: 'flujo_auto',
      patente: '',
      tipo_aceite: '',
    };

    state.searchData = normalizar_search_data(next);
    setToStorage(STORAGE_SEARCH, state.searchData);
  },
  
  SET_ACEITE_SEARCH: function(state, { local, tipo_aceite }) {
    state.searchData = {
      ...state.searchData,
      marca: '',
      marca_logo: '',
      ano: '',
      modelo: '',
      version: '',
      local,
      modo_busqueda: 'por_aceite',
      flujo_agendamiento: 'flujo_aceite',
      patente: '',
      tipo_aceite,
    };
    setToStorage(STORAGE_SEARCH, state.searchData);
  },



  // Sets - Info Especificaciones
  SET_INFO_ESPECIFICACIONES: function(state, especificaciones) {
    state.info_especificaciones = especificaciones;
    setToStorage(STORAGE_INFO_ESPECIFICACIONES, state.info_especificaciones);
  },

  // Sets - Producto Seleccionado (con merge)
  SET_PRODUCTO_SELECCIONADO: function(state, producto) {
    if (state.producto_seleccionado) {
      state.producto_seleccionado = {
        ...state.producto_seleccionado,
        ...producto
      };
    } else {
      state.producto_seleccionado = producto;
    }
    setToStorage(STORAGE_PRODUCTOS, state.producto_seleccionado);
  },

  // Sets - Detalle Agendamiento
  SET_DETALLE_AGENDAMIENTO: function(state, data) {
    state.detalle_agendamiento = { 
      ...state.detalle_agendamiento, 
      ...data 
    };
    setToStorage(STORAGE_DETALLE_AGENDAMIENTO, state.detalle_agendamiento);
  },



  // NUEVO - Sets - Personal Information
  SET_PERSONAL_INFORMATION: function(state, personalInfo) {
    state.personalInformation = {
      ...state.personalInformation,
      ...personalInfo
    };
    setToStorage(STORAGE_PERSONAL_INFORMATION, state.personalInformation);
  },

  SET_CALENDARIO(state, payload) {
    state.calendar = { ...state.calendar, ...payload };
    setJSON(STORAGE_SCHEDULE, state.calendar);
  },

  setTempario(state, { tempario, scheduleType = 3 }) {
    const next = { ...state.calendar, tempario, scheduleType: parseInt(scheduleType) };
    mutations.SET_CALENDARIO(state, next);
  },
};

const getters = {
  getFullData: function(state) {
    return {
      searchData: state.searchData,
      producto_seleccionado: state.producto_seleccionado,
      info_especificaciones: state.info_especificaciones,
      detalle_agendamiento: state.detalle_agendamiento,
      personalInformation: state.personalInformation, // NUEVO
    }
  },

  getSearchData: function(state) {
    return state.searchData;
  },
  
  getProductoSeleccionado: function(state) {
    return state.producto_seleccionado;
  },

  getInfoEspecificaciones: function(state) {
    return state.info_especificaciones;
  },

  getDetalleAgendamiento: function(state) {
    return state.detalle_agendamiento;
  },

  // NUEVO
  getPersonalInformation: function(state) {
    return state.personalInformation;
  },

};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions: {}
};